<template>
  <div>
    <welcome :app-name="app.name" />
  </div>
</template>

<script>
import { checkLogin, getAppInfoByCode } from '@/api/user-api.js'
import $utils from '../../utils/utils'
import Welcome from '../../components/welcome.vue'

export default {
  components: {
    Welcome
  },
  data() {
    return {
      pucAppId: '',
      loginList: {},
      app: {},
      queryEnterPath: '',
      appCode: '',
    }
  },
  watch: {
    app(newVal) {
      this.gotApp(newVal)
    }
  },
  created() {
    sessionStorage.removeItem('mobile-login-refresh')
    sessionStorage.removeItem('mobile-product-refresh')
    if ($utils.isMobile() && !sessionStorage.getItem('mobile-welcome-refresh')) {
      sessionStorage.setItem('mobile-welcome-refresh', '1')
      window.location.reload()
      return
    }
    this.pucAppId = this.$route.query.pucAppId
    this.queryEnterPath = this.$route.query.enterPath
    this.appCode = this.$route.query.appCode
    if (this.$route.query.token) {
      localStorage.setItem('token', this.$route.query.token)
    }
    if (this.$route.query.sessionId) {
      sessionStorage.setItem('sessionId', this.$route.query.sessionId)
    }
    this.getCheck()
  },
  mounted() {
  },
  methods: {
    async getCheck() {
      if (this.appCode && !this.pucAppId) {
        const appInfo = await getAppInfoByCode({ appCode: this.appCode })
        if (!appInfo) {
          return this.$message.error('暂无权限，请联系管理员')
        } else {
          this.pucAppId = appInfo.appId
        }
      }
      const res = await checkLogin({
        appId: this.pucAppId || ''
      })
      this.loginList = res
      this.app = res.app || {}
    },
    async gotApp(item) {
      if (!this.loginList.accessible) {
        this.$message.warning(this.loginList.message)
        return setTimeout(() => {
          this.$router.go(-1)
        }, 500)
      }
      let url = this.loginList.appHomePage
      if (sessionStorage.getItem('enterPath')) {
        url = sessionStorage.getItem('enterPath')
      }
      if (this.queryEnterPath) {
        url = decodeURIComponent(this.queryEnterPath)
      }
      sessionStorage.removeItem('enterPath')
      const pucAppId = item.appId || ''
      // 接口返回的数据，跳转的url需要加上参数
      if (item.appId) {
        const token = localStorage.getItem('token')
        const sessionId = sessionStorage.getItem('sessionId') || ''
        const code = item.code || ''
        const adminUrl = process.env.VUE_APP_ADMIN_URL
        if (/.*\.html\?.*/.test(url)) {
          url = `${adminUrl}${url}&pucAppId=${pucAppId}&token=${token}&sessionId=${sessionId}`
        } else {
          url = `${adminUrl}${url}?code=${code}&pucAppId=${pucAppId}&token=${token}&sessionId=${sessionId}`
        }
      }
      window.location.href = url
      sessionStorage.removeItem('mobile-welcome-refresh')
    },
  }
}
</script>

<style>

</style>
